<template>
  <van-popup v-model="show" @close="AUTHORIZE_POPUP_SHOW(false)">
    <div class="box">
      <div class="login-title">
        <i class="iconfont icon-close tapActive" @click="AUTHORIZE_POPUP_SHOW(false)"></i>
      </div>
      <div class="login-input">
        <div class="logoBox">
          <img src="@/assets/image/logo.png" alt="" class="logo" />
          <div class="tip">
            <div class="top">
              <span>搜</span>
              <span>货</span>
              <span>精</span>
              <span>选</span>
            </div>
            <div class="bottom">据说这里经常免费送礼物</div>
          </div>
        </div>
        <div class="bottomPart">
          <div class="btnBox">
            <div class="btnList">
              <div class="btn weixin" :class="isAgree ? 'tapActive' : 'normal'" @click="toAuthorize('weixin')">
                <i class="iconfont icon-weixin1"></i>
              </div>
              <div class="btn apple" :class="isAgree ? 'tapActive' : 'normal'" @click="toAuthorize('apple')" v-if="isShowAppleLoginBtn">
                <i class="iconfont icon-pingguo"></i>
              </div>
            </div>
          </div>
          <!-- 协议部分 -->
          <div class="agreementPart">
            <div class="con">
              <i class="iconfont" :class="isAgree ? 'active icon-dagou' : 'icon-kuang'" @click="isAgree = !isAgree"></i>
              <span @click="isAgree = !isAgree">同意</span>
              <span class="link" @click="enterToDetail('userAgreement')">《用户协议》</span>与
              <span class="link" @click="enterToDetail('privacyAgreement')">《隐私协议》</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import { mapGetters, mapMutations } from 'vuex'
import baseUtil from '@/utils/base'
export default {
  name: 'AuthorizePopup',
  components: {
    'van-popup': Popup
  },
  data() {
    return {
      show: true,
      isAgree: false
    }
  },
  computed: {
    ...mapGetters(['getAuthorizePopupShow', 'getIsApp', 'getIosIsShowLoginBtn']),
    isShowAppleLoginBtn() {
      return baseUtil.isIOS() && this.getIosIsShowLoginBtn
    }
  },
  methods: {
    ...mapMutations(['AUTHORIZE_POPUP_SHOW']),
    toAuthorize(provider) {
      // 优先判断用户是否已勾选【同意《用户协议》&《隐私协议》】，未勾选则给出toast提示：请先阅读并同意协议
      if (!this.isAgree && this.getIsApp) {
        this.$toast('请先阅读并同意协议')
        return
      }
      this.$uni.postMessage({
        data: {
          toAuthorize: true,
          provider: provider
        }
      })
      this.show = false
    },
    // 跳转到协议
    linkToAgreement(agreementName) {
      this.$router.push(agreementName)
      // switch (agreementName) {
      //   case "userAgreement":
      //     this.$uni.postMessage({
      //       data: {
      //         linkToUserAgreement: true,
      //       },
      //     });
      //     break;
      //   case "privacyAgreement":
      //     this.$uni.postMessage({
      //       data: {
      //         linkToPrivacyAgreement: true,
      //       },
      //     });
      //     break;
      //   default:
      //     break;
      // }
    },
    enterToDetail(tempRouterName) {
      this.AUTHORIZE_POPUP_SHOW(false)
      this.$router.push(tempRouterName)
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  background: #fff;
  width: 296px;
  border-radius: 10px;
  box-sizing: border-box;
  font-size: 16px;
  padding: 20px 0;
  min-height: 320px;
  .login-title {
    position: relative;
    /* line-height: 40px; */
    font-size: 18px;
    font-weight: 600;
    padding-left: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 18px;
  }
  .login-title .iconfont {
    /* position: absolute;
    right: 0px;
    top: 0; */
    width: 40px;
    /* text-align: center; */
    color: #666;
    cursor: pointer;
  }
  .logoBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    .logo {
      width: 56px;
      height: 56px;
      border-radius: 4px;
    }
    .tip {
      margin-top: 10px;
      .top {
        display: flex;
        justify-content: space-between;
        font-size: 22px;
        line-height: 36px;
      }
      .bottom {
        color: #c5c5c5;
        font-size: 14px;
      }
    }
  }
  .login-input {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
    .login-btn {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 181px;
      width: 230px;
      height: 36px;
      line-height: 36px;
      border-radius: 30px;
      background: #1cc21b;
      text-align: center;
      color: #fff;
      margin: 0 auto;
      font-size: 14px;
      .btnCon {
        display: flex;
        align-items: center;
        .iconfont {
          margin-right: 6px;
          font-size: 20px;
        }
      }
    }
    .login-btn.normal {
      background-color: #77c777;
      opacity: 0.6;
    }
    .btnBox {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .btnList {
        display: flex;
        .btn {
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 45px;
          height: 45px;
          background-color: aqua;
          margin-right: 20px;
          border-radius: 50%;
          .iconfont {
            font-size: 30px;
          }
          &:last-child {
            margin-right: 0;
          }
          &.normal {
            opacity: 0.6;
          }
          &.weixin {
            background: #1cc21b;
            color: #fff;
          }
          &.apple {
            background: #000000;
            color: #ffffff;
          }
        }
      }
    }
  }
}
.van-popup {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  background-color: transparent;
  overflow: initial;
}
</style>
